import Marionette from 'backbone.marionette';
import $ from 'jquery';

var ModalView = Marionette.LayoutView.extend({
    template: require('base/templates/modal.html'),

    regions: {
        content: '.modal-contents'
    },

    ui: {
        close: '.closeButton'
    },

    triggers: {
        'click @ui.close': 'close'
    },
    
    close(){
        this.el.remove();
        this.destroy();
    }
});

/**
 * Service to deal with dialogs in Fund Manager
 */
class DialogService{
    /**
     * Show `view` in a dialog.
     * 
     * @return ModalView
     */
    static show(view){
        let m = new ModalView({
            el: $('<div>').addClass('modal-holder').appendTo('body')
        });
        m.render();
        view.modal = m;
        m.showChildView('content', view);
        return m;
    }
}

export default DialogService;



// WEBPACK FOOTER //
// ./base/dialog_service.js